
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.991 1.2a4.784 4.784 0 00-3.307 1.33l-.691-.692a.465.465 0 00-.793.329V4.76c0 .257.208.465.465.465h2.594c.414 0 .621-.5.329-.793l-.808-.808a3.252 3.252 0 11.08 4.823.232.232 0 00-.318.01l-.768.768a.233.233 0 00.01.337A4.8 4.8 0 0010.8 6a4.808 4.808 0 00-4.809-4.8z","fill":"#282E3E"}})])
          )
        }
      }
    